import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getDropdownData,
  getPendingKyc,
  reviewKycSubmit,
  updateKycData,
} from "../../redux/slices/EnqMngtSlice";
import { Form, Typography, Checkbox } from "antd";
import CustomCard from "../../components/CustomCard/CustomCard";
import KycBusinessDetails from "./Components/KycBusinessDetails";
import { TITLE_TXT, BTN_TXT } from "../../constants/constants";
import KycAddress from "./Components/KycAddress";
import KycBank from "./Components/KycBank";
import KycAdditionalInfo from "./Components/KycAdditionalInfo";
import "./EnqMngt.scss";
import KycContactDirector from "./Components/KycContactDirector";
import KycUploadDocs from "./Components/KycUploadDocs";
import FormFooter from "../../components/CustomForms/FormFooter";
import dayjs from "dayjs";
const { Text } = Typography;

const ReviewKyc = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const navigate = useNavigate();
  const { pendingKycData, reviewKycSubmitLoading, error } = useSelector(
    (state) => state?.enqMngt
  );
  const formValues = Form.useWatch(undefined, form);
  const {
    busPan,
    busName,
    gstin,
    email,
    phoneNo,
    ifsc,
    accNum,
    accHolderName,
  } = formValues || {};
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  useEffect(() => {
    dispatch(getDropdownData());
    dispatch(getPendingKyc(orgId));
  }, [orgId, dispatch]);

  useEffect(() => {
    if (pendingKycData) {
      form.setFieldsValue({
        busName: pendingKycData?.busName,
        busPan: pendingKycData?.pan,
        busType: pendingKycData.businessTypeId,
        incorporationDate: dayjs(pendingKycData.incorporationDate),
        industryType: pendingKycData.industryTypeId,
        annualTurnover: pendingKycData.annualTurnoverId,
        hasMultipleGstin: pendingKycData.hasMultipleGstin,
        gstin: pendingKycData.gstin,
        primaryAdd1: pendingKycData.primaryAddLine1,
        primaryAdd2: pendingKycData.primaryAddLine2,
        primaryCity: pendingKycData.primaryCityName,
        primaryState: pendingKycData.primaryStateName,
        primaryPincode: pendingKycData.primaryZipCode,
        commAdd1: pendingKycData.billingAddLine1,
        commAdd2: pendingKycData.billingAddLine2,
        commCity: pendingKycData.billingCityName,
        commState: pendingKycData.billingStateName,
        commPincode: pendingKycData.billingZipCode,
        email: pendingKycData.email,
        phoneNo: pendingKycData.contactPhoneNumber,
        ifsc: pendingKycData.BankDetailsView?.ifscCode,
        bankName: pendingKycData.BankDetailsView?.bankName,
        branchName: pendingKycData.BankDetailsView?.branchName,
        accHolderName:
          pendingKycData?.busName ||
          pendingKycData.BankDetailsView?.accHolderName,
        accNum: pendingKycData.BankDetailsView?.accNum,
        tenure: pendingKycData?.expectedTenure?.toString(),
        expAmt: pendingKycData.expectedCredit,
        busWebsite: pendingKycData.busWebsite,
        dealType: pendingKycData.dealCategoryId,
        busDesc: pendingKycData.busDescription,
        finSummary: pendingKycData.financialSummary,
        dirName: pendingKycData.directorName,
        dirAadhaar:
          pendingKycData?.kycDetails?.kycDirectorsAadhaarValue?.docValue,
        dirPan: pendingKycData?.kycDetails?.kycDirectorsPanValue?.docValue,
      });
    }
  }, [pendingKycData, form]);

  const handleFileChange = (key, file) => {

  };

  const handleSubmitKyc = async (values) => {

    const result = await dispatch(reviewKycSubmit({ orgId }));

    if (result.payload.statusCode === 201) {
      navigate(-1);
      dispatch(updateKycData())
    }
  };

  return (
    <div className="complete-kyc-container">
      <Text className="kyc-title">
        KYC Details for{" "}
        <span style={{ fontWeight: "bold" }}>{pendingKycData?.busName}</span>
      </Text>
      <CustomCard className="complete-kyc-card">
        <Form layout="vertical" form={form} onFinish={handleSubmitKyc}>
          <Text className="kyc-subtitle">{TITLE_TXT.BUS_DETS}</Text>
          <KycBusinessDetails
            kycData={pendingKycData?.kycDetails?.kycPanValue}
            busPan={busPan}
            busName={busName}
            orgId={orgId}
            isReview={true}
          />
          <KycContactDirector
            kycData={pendingKycData?.kycDetails}
            email={email}
            phoneNo={phoneNo}
            orgId={orgId}
            form={form}
            isReview={true}
            dealCategoryId={pendingKycData?.dealCategoryId}
          />
          <KycBank
            kycData={pendingKycData?.kycDetails}
            ifsc={ifsc}
            accNum={accNum}
            accHolderName={accHolderName}
            orgId={orgId}
            form={form}
            isReview={true}
          />
          <Text className="kyc-subtitle">{TITLE_TXT.ADD_VERIFY}</Text>
          <KycAddress
            kycData={pendingKycData?.kycDetails?.kycGstinValue}
            gstin={gstin}
            form={form}
            orgId={orgId}
            isReview={true}
          />
          <KycAdditionalInfo isReview={true} />
          <Text className="kyc-subtitle">{TITLE_TXT.UPLOAD_DOCS}</Text>
          <KycUploadDocs
            kycData={pendingKycData}
            busType={pendingKycData?.businessTypeId}
            orgId={orgId}
            onFileChange={handleFileChange}
            isReview={true}
          />
          <Form.Item style={{ marginTop: 20 }}>
            <Checkbox
              checked={isTermsAccepted}
              onChange={(e) => setIsTermsAccepted(e.target.checked)}
            >
              I confirm that I have verified and uploaded all the information
              provided for the company {busName}.
            </Checkbox>
          </Form.Item>
          <FormFooter
            onCancelClick={() => {
              navigate(-1);
              form.resetFields();
            }}
            error={error}
            submitLoading={reviewKycSubmitLoading}
            btnName={BTN_TXT.SUBMIT}
            disabled={!isTermsAccepted}
          />
        </Form>
      </CustomCard>
    </div>
  );
};

export default ReviewKyc;
